import { JSX } from "react";

const DistributorGenrePage = (): JSX.Element => {
  return (
    <section className={"bg-surface-bright mt-5 rounded-7.5 p-5 max-lg:rounded-5"}>
      <h1 className={"text-2xl font-semibold"}>Фильмы Amediateka</h1>
      <div className={"movies-grid mt-7"}>
        {/* {new Array(29)
          .fill("https://cdn.splay.uz/media/contents_meta/pchelovodru/images/poster_h.medium.jpg")
          .map((item, i) => (
            <MovieCard
              key={i}
              image={item}
              title={"title"}
              link={ROUTES.DETAIL.MAIN.replace(":id", i.toString())}
              isNew={false}
              isViewed={false}
            />
          ))} */}
      </div>
    </section>
  );
};

export default DistributorGenrePage;
